/**
 * created by tian ruo jun
 表单子项
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Input, Select} from "antd";
const { TextArea } = Input;

export default class FormItem extends Component {
    static defaultProps = {
        type: "text",
        onChange: ()=>{},
        value: "",
    };
    static propTypes = {
        type: PropTypes.string.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    formItemControl = () => {
        let {value,disabled,field,onChange} = this.props;
        return {
            'text':<Input
                placeholder={`请输入`}
                disabled={disabled}
                value={value}
                onChange={(e) => {
                    let val = e.target.value || '';
                    onChange(field, val)
                }}
            />,
            'select':<Select
                placeholder={`请选择`}
                disabled={disabled}
                value={value}
            />,
            'textarea':<TextArea
                rows={1}
                placeholder={`请输入`}
                disabled={disabled}
                value={value}
                onChange={(e) => {
                    let val = e.target.value || '';
                    onChange(field, val)
                }}
            />
        }
    };

    render() {
        return (
            this.formItemControl()[this.props.type]
        )
    }

}